import styled from '@emotion/styled'

import Button from '../../components/common/Button'
import { useLoginAD } from '../../services/auth/auth-query'
import { SECONDARY } from '../../constant/colors'

const Layout = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 16px;
  border: 3px solid ${SECONDARY};
  padding: 24px;
  margin: 24px;
  border-radius: 8px;

  .header {
    text-align: center;
    grid-column: 1/3;
    color: rgba(10, 10, 10, 0.8);
    font-family: IBMPlexSansThai-Bold;
    font-size: 32px;
    font-weight: 900;
    text-shadow: 0px 0px 1px black;
  }
`
const debugUsers = [
  { email: 'hr.digit@BLCPPOWER.onmicrosoft.com' },
  { email: 'hr.digit.dir@blcp.co.th' },
  { email: 'hr.digit.sup@blcp.co.th' },
  { email: 'hr.digit.mgr@blcp.co.th' },
] as const

const DebugLogin = () => {
  const { mutate: loginAD } = useLoginAD()
  return (
    <Layout>
      <div className="header">Debug Login</div>
      {debugUsers.map((user, index) => {
        return (
          <Button
            key={`${user.email}-${index}`}
            onClick={() => {
              loginAD({
                username: user.email,
                tokenId: '1234',
                app: '',
              })
            }}
          >
            {user.email.split('@')[0]}
          </Button>
        )
      })}
    </Layout>
  )
}

export default DebugLogin
